<div class="register">
  <aside
    [ngClass]="{ 'register__art-area--gift': flowMode === 'gift' }"
    class="register__art-area"
    [attr.aria-hidden]="flowMode === 'gift' ? 'true' : null"
  >
    <div class="art-area-container">
      @if (flowMode === "gift") {
        <img
          alt=""
          class="art-area__logo art-area__logo--white"
          width="99"
          height="32"
          ngSrc="assets/icon/cariloop-logo.svg"
        />
      } @else {
        <img
          alt=""
          class="art-area__logo"
          width="113"
          height="32"
          ngSrc="assets/icon/Cariloop-Logo-Black.svg"
        />
      }

      @if (flowMode === "gift") {
        <div class="art-area-section">
          <img
            alt=""
            class="art-area-section__img"
            height="93"
            ngSrc="assets/img/Gift_Boxes.svg"
            width="241"
          />
          <p class="art-area-section__title">
            {{ getArtAreaTitle() | translate }}
          </p>
          <p class="art-area-section__text">
            {{ "REGISTER.ART_GENERIC_DESCRIPTION" | translate }}
          </p>
        </div>
      } @else {
        <div class="art-area-brand">
          <div class="art-area-brand__text">
            <p class="art-area-brand__title">
              <span>{{ "REGISTER.ART_BRAND_TITLE_PREFIX" | translate }}</span
              ><em class="art-area-brand__title--highlight">{{
                "REGISTER.ART_BRAND_TITLE_HIGHLIGHT" | translate
              }}</em
              ><span>{{ "REGISTER.ART_BRAND_TITLE_SUFFIX" | translate }}</span>
            </p>
            <p class="art-area-brand__subtitle">
              {{ "REGISTER.ART_BRAND_SUBTITLE" | translate }}
            </p>
          </div>
          <ul class="art-area-brand__benefits" role="list">
            <li class="art-area-brand__benefits-item">
              <span
                class="material-symbols-rounded art-area-brand__check-icon"
                aria-hidden="true"
                >check</span
              >
              <span>{{ "REGISTER.ART_BRAND_BENEFIT_1" | translate }}</span>
            </li>
            <li class="art-area-brand__benefits-item">
              <span
                class="material-symbols-rounded art-area-brand__check-icon"
                aria-hidden="true"
                >check</span
              >
              <span>{{ "REGISTER.ART_BRAND_BENEFIT_2" | translate }}</span>
            </li>
            <li class="art-area-brand__benefits-item">
              <span
                class="material-symbols-rounded art-area-brand__check-icon"
                aria-hidden="true"
                >check</span
              >
              <span>{{ "REGISTER.ART_BRAND_BENEFIT_3" | translate }}</span>
            </li>
          </ul>
        </div>
      }
    </div>
  </aside>
  <div class="register__form-area">
    <div class="form-area--form">
      <ng-content></ng-content>
    </div>
  </div>
  <footer class="registration-footer">
    <span>
      {{ "REGISTER.FOOTER" | translate }}
      <a class="registration-footer-phone" href="mailto:support@cariloop.com">
        support&#64;cariloop.com
      </a></span
    >
  </footer>
</div>
